import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import AppAnimate from "../../../components/AppAnimate";
import Grid from "@material-ui/core/Grid/Grid";
import VisitsChart from "../../../components/charts/VisitsChart";
import Title from "../../../components/elements/Title";
import Clock from "../../../components/elements/Clock";
import PeopleRoundedIcon from '@material-ui/icons/PeopleRounded';
import AppCard from "../../../components/layouts/components/AppCard";
import Button from "@material-ui/core/Button/Button";
import PollRoundedIcon from '@material-ui/icons/PollRounded';
import LiveUsers from "./components/LiveUsers";
import TodayAnalytics from "./components/TodayAnalytics";
import OrdersAnalytics from "./components/OrdersAnalyticsShort";
import OrdersChart from "../../../components/charts/OrdersChart";
import Permission from "../../../components/elements/Permission";
import Feature from "../../../components/elements/Feature";
import SubTitle from "../../../components/elements/SubTitle";

class AdminDashboard extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.dashboard}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12} md={9}>
                        <AppCard>
                            <SubTitle align="left">
                                {Translate.visitsChart}
                            </SubTitle>
                            <div style={{height:300,direction:"ltr"}}>
                                <VisitsChart/>
                            </div>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12} md={3} >
                        <AppCard
                            style={{height:"100%"}}>
                            <Title><PeopleRoundedIcon fontSize="large"/> <br/> {Translate.liveUsers} </Title>
                            <Grid item xs={12} >
                                <Clock/>
                            </Grid>
                            <Grid item xs={12} >
                                <LiveUsers/>
                            </Grid>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withStyles(Styles)(AdminDashboard);